import React from "react";
import "./PartenairesTossStyles.css";
import Navbar from "../../components/modules/Navbar";
import { BsFileArrowDown } from "react-icons/bs";
import { Link as LinkScroll } from "react-scroll";
import { AiOutlineArrowRight } from "react-icons/ai";
import { useState, useEffect, useRef } from "react";
import ScrollTrigger from "gsap/ScrollTrigger";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { isMobile, BrowserView } from "react-device-detect";
import Footer from "../../components/modules/Footer";
import { useTranslation } from "react-i18next";

//Logo entreprises
import logoToss from "../../assets/logo_toss_noir.png";
import mazarsLogo from "../../assets/partenaires/logoMazars.png";
import caisseEpargneLogo from "../../assets/partenaires/caisse_epargne.png";
import pepsiLogo from "../../assets/partenaires/pepsi.png";
import androsLogo from "../../assets/partenaires/benuts.png";
import lydia from "../../assets/partenaires/lydia.png";
import saclay from "../../assets/partenaires/saclay.png";
import polytechnique from "../../assets/partenaires/x.png";
import idf from "../../assets/partenaires/idf.png";
import cs from "../../assets/partenaires/cs.png";
import kryole from "../../assets/partenaires/kryole.png";
import lifting from "../../assets/partenaires/lifting.png";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const PartenairesToss = () => {
  const { t } = useTranslation("common");

  const desactive = false;
  const [bolde, setBold] = useState(false);
  const myRef = useRef();

  const PinElement = (elem, elem2) => {
    gsap.fromTo(
      elem,

      {
        y: 0,
      },
      {
        y: 0,
        duration: 4,
        scrollTrigger: {
          trigger: elem2,
          start: "top 20%",
          end: "bottom 70%",

          toggleActions: "play reset resume pause",
          pin: elem,
          pinSpacing: false,
        },
      }
    );
  };
  const BoldeTitle = (elem) => {
    gsap.fromTo(
      elem,

      {
        y: 0,
      },
      {
        y: 0,
        duration: 0.001,
        scrollTrigger: {
          trigger: elem,
          start: "top center",
          end: "bottom center",

          toggleActions: "play reset play reset",
        },
        onComplete: function () {
          setBold(elem);
        },
      }
    );
  };

  useEffect(() => {
    if (!isMobile) {
      PinElement(".partenaires-title-content", "#partenaires-presentation");
      BoldeTitle("#textile");
      BoldeTitle("#officiel");
      BoldeTitle("#institution");
      BoldeTitle("#autres");
      BoldeTitle("#logistique");
      BoldeTitle("#inedit");
    }
  }, []);

  const onLoad = () => {
    gsap.timeline().fromTo(
      "#on",
      {
        y: 50,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
      }
    );
  };

  useEffect(() => {
    onLoad();
  }, []);

  return (
    <div>
      <Navbar scroll="false" color="transparent" />
      <div className="partenaires-toss" id="part">
        <div className="partenaires-toss-home">
          <div className="partenaires-toss-title">
            <h1 id="on"> {t("partenaires.title")}</h1>
          </div>
          <LinkScroll
            to="partenaires-presentation"
            smooth={true}
            offset={0}
            duration={1000}
          >
            {" "}
            <BsFileArrowDown
              style={{ color: "white" }}
              className="fleche-mazars"
            />
          </LinkScroll>
          <div className="vague">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
              <path
                fill="#ffffff"
                fillOpacity="1"
                d="M0,288L60,288C120,288,240,288,360,266.7C480,245,600,203,720,208C840,213,960,267,1080,288C1200,309,1320,299,1380,293.3L1440,288L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
              ></path>
            </svg>
          </div>
        </div>

        <div
          className="partenaires-presentation"
          id="partenaires-presentation"
          ref={myRef}
        >
          <div
            className={
              desactive
                ? "partenaires-title-content desactive"
                : "partenaires-title-content"
            }
          >
            <div>
              <div className="partenaires-image-toss">
                <img  src={logoToss} alt="" />
              </div>
              <ul className="partenaires-category" id="partenaires-category">
                <li className={bolde === "#officiel" ? "bold" : ""}>
                  <LinkScroll
                    to="officiel"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      {t("partenaires.cat1")}{" "}
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>
                <li className={bolde === "#inedit" ? "bold" : ""}>
                  <LinkScroll
                    to="inedit"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      Partenaire inédit
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>
                
                <li className={bolde === "#logistique" ? "bold" : ""}>
                  <LinkScroll
                    to="logistique"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      {t("partenaires.cat5")}
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>
                <li className={bolde === "#institution" ? "bold" : ""}>
                  <LinkScroll
                    to="institution"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      {t("partenaires.cat3")}
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>
                <li className={bolde === "#textile" ? "bold" : ""}>
                  <LinkScroll
                    to="textile"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      {t("partenaires.cat4")}
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>

                <li className={bolde === "#autres" ? "bold" : ""}>
                  <LinkScroll
                    to="autres"
                    smooth={true}
                    offset={-250}
                    duration={1000}
                  >
                    <h2>
                      {t("partenaires.cat6")}
                      <AiOutlineArrowRight className="fleche-partenaire" />
                    </h2>
                  </LinkScroll>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="partenaires-content">
            <div className="partenaires-inner" id="officiel">
              <div className="partenaires-inner-image">
                <img  src={mazarsLogo} alt="" />
              </div>
              <div className="partenaires-inner-content">
                <BrowserView>
                  <h3> Forvis Mazars</h3>
                </BrowserView>
                <p> {t("partenaires.mazars")}</p>
              </div>
            </div>

            <div id="inedit">
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={caisseEpargneLogo} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> Caisse d'Épargne Île-de-France</h3>
                  </BrowserView>
                  <p> {t("partenaires.caisseEpargne")}</p>
                </div>
              </div>

              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={pepsiLogo} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> Pepsi</h3>
                  </BrowserView>
                  <p> {t("partenaires.pepsi")}</p>
                </div>
              </div>

              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={androsLogo} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> Andros Be Nuts</h3>
                  </BrowserView>
                  <p> {t("partenaires.andros")}</p>
                </div>
              </div>
            </div>
            
            <div id="logistique">
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={kryole} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> K-ryole</h3>
                  </BrowserView>
                  <p> {t("partenaires.kryole")}</p>
                </div>
              </div>
              
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={lydia} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> Lydia</h3>
                  </BrowserView>
                  <p> {t("partenaires.lydia")} </p>
                </div>
              </div>
            </div>

            <div id="institution">
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={cs} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    {" "}
                    <h3> CentraleSupélec</h3>
                  </BrowserView>
                  <p> {t("partenaires.cs")} </p>
                </div>
              </div>
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={idf} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    {" "}
                    <h3> Ile de France</h3>
                  </BrowserView>
                  <p> {t("partenaires.idf")} </p>
                </div>
              </div>
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={polytechnique} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    {" "}
                    <h3> Polytechnique</h3>
                  </BrowserView>
                  <p>{t("partenaires.X")}</p>
                </div>
              </div>
              <div className="partenaires-inner">
                <div className="partenaires-inner-image">
                  <img  src={saclay} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    {" "}
                    <h3> Université Paris-Saclay</h3>
                  </BrowserView>
                  <p> {t("partenaires.uni")} </p>
                </div>
              </div>
              <div className="partenaires-inner" id="textile">
                <div className="partenaires-inner-image">
                  <img  src={lifting} alt="" />
                </div>
                <div className="partenaires-inner-content">
                  <BrowserView>
                    <h3> Agence Lifting</h3>
                  </BrowserView>
                  <p> {t("partenaires.ffsu")} </p>
                </div>
              </div>
            </div>          
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PartenairesToss;
